import { render } from "./EditDevice.vue?vue&type=template&id=2b9a2822&scoped=true"
import script from "./EditDevice.vue?vue&type=script&lang=js"
export * from "./EditDevice.vue?vue&type=script&lang=js"

import "./EditDevice.vue?vue&type=style&index=0&id=2b9a2822&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9a2822"]])

export default __exports__